import React from "react";
import Table from "@/components/reports";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import { i18n } from "@/utils/i18n";

const Reports: React.FC = () => {
    return <Table reviewStatus="0,4" title={i18n.t("reportOverview")} />;
};

export default withErrorBoundary({ component: "Reports page" })(Reports);
